module.exports = "/virtual-football-league/img/standings-red-dress.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/standings-red-dress.png
// module id = 2244
// module chunks = 4